<script setup>
import {computed, onMounted, ref, watch} from "vue";
import store from "@/store";
import LoginComponents from "@/components/login/LoginComponents.vue";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";
import {siteConfig} from "@/utils/config";
import XmLogin from "@/components/login/xmLogin.vue";

const scroll = ref()
const order = ref([])
const account = computed(() => store.state.account)
const showLogin = ref(false)
const page = ref(1)
const lastPage = ref(1)
watch(account, (to) => {
  if (Object.keys(to).length || order.value.length < 1) {
    page.value = 1
    getOrder()
  }
})
const couponType = computed(() => {
  let types = store.state.coupon
  document.title = siteConfig[types]?.title
  return types
})
const orderView = computed(() => {
  if (couponType.value && siteConfig[couponType.value]) return siteConfig[couponType.value]?.components?.order?.view
})
onMounted(async () => {
  store.commit("getCoupon")
  await store.dispatch("getAccounts")
})
const getOrder = () => {
  if (Object.keys(account.value).length < 1) {
    showLogin.value = true;
    return;
  }
  showLogin.value = false;

  new axiosApi({
    encode: !/^shuangke.*/.test(couponType.value) ? "coupon" : "site",
    method: !/^shuangke.*/.test(couponType.value) ? "life/orderLst" : "coupon/orderLst",
    body: !/^shuangke.*/.test(couponType.value) ? {
      cust_id: account.value.cust_id,
      type: couponType.value,
      page: page.value
    } : {
      uid: account.value.uid,
      page: page.value,
      business: "shuangke"
    }
  }).send(res => {
    if (res.message.code === "000") {
      if (couponType.value !== "shuangke") {
        res.data.data.forEach(item => {
          if (item.goodsItems && item.goodsItems.remarks) {
            let remarks = JSON.parse(item.goodsItems.remarks)
            item.remark = remarks
            if (remarks.goodsImg) {
              item.goodsImgs = require(`@/assets/images/${couponType.value}/${remarks.goodsImg}.png`)
            }
          }
        })
      }
      order.value = page.value === 1 ? res.data.data : order.value.concat(res.data.data)
      lastPage.value = res.data.last_page
    }
  })
}
const onScrollbar = (refs) => {
  let warp = refs.wrapRef;
  const poor = warp.scrollHeight - warp.clientHeight;
  if (poor === parseInt(warp.scrollTop) || poor === Math.ceil(warp.scrollTop) || poor === Math.floor(warp.scrollTop)) {
    if (page.value < lastPage.value) {
      page.value++;
      getOrder()
    }
  }
}
</script>

<template>
  <div class="order-lst" :class="`${couponType}-order`">
    <div class="header">
      <div @click="router.replace({name:'home'})">
        <el-icon>
          <ArrowLeft/>
        </el-icon>
      </div>
      <div>兑换记录</div>
      <div></div>
    </div>
    <el-scrollbar class="order-info" ref="scroll" @scroll="onScrollbar(scroll)">
      <component :is="orderView" :order="order"/>
    </el-scrollbar>
  </div>

  <xm-login :show-login="showLogin" @login="showLogin=false"
            v-if="showLogin && siteConfig[couponType].login === 'xm_air'"/>
  <login-components :show-login="showLogin" @login="showLogin=false" v-else-if="showLogin"/>
</template>

<style scoped lang="less">
.order-lst {
  background-size: 100%;
  box-sizing: border-box;
  padding: 15px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #ffffff;
    font-size: 1.35rem;
  }

  &.shuyi-order {
    background: url("@/assets/images/shuyi/order-banner.png") no-repeat;
  }

  &.luckin-order {
    background: url("@/assets/images/luckin/order-banner.png") no-repeat;
  }

  &.qiaopai-order {
    background: url("@/assets/images/qiaopai/order-banner.png") no-repeat;
  }

  &.douyin-order {
    background: url("@/assets/images/douyin/order-banner.png") no-repeat;
  }

  &.nakebao-order {
    background: url("@/assets/images/nakebao/order-banner.png") no-repeat;
  }

  &.shuangke-order, &.shuangke-xmair-order {
    background: url("@/assets/images/shuangke/order-banner.png") no-repeat;
  }

  &.fandeng-order {
    background: url("@/assets/images/fandeng/order-bg.png") no-repeat;

    .header {
      color: #000000;
    }
  }

  .order-info {
    height: calc(100vh - 80px);
    margin-top: 15px;


  }
}
</style>
